import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setDefaultSubjectCategory } from '../services/subjectCategoryService';

export function useSetDefaultSubjectCategory(queryParams = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setDefaultSubjectCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['subjectCategories', queryParams],
      });
    },
  });
}
